import styled from "styled-components";

//forms
export const Forms = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 30px;
    width: 100%;
    max-height: 100%;
    height: 100%;

    overflow-y: auto;

    &::-webkit-scrollbar { 
        display: none;
    }

    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 1px 1px 8px 0px ${(props) => props.theme.colors.gray.gray_50};
    padding: 10px;

    @media (max-width: 900px) {
        height: 100vh;
    }
`;

export const SeparateDiv = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 20px;
    width: 100%;

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const SeparateInput = styled.div`
    display: flex;
    gap: 20px;

    @media (max-width: 900px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

//PopMenu
export const ContentPopMenu = styled.div`
    width: 100%;
    position: relative;
`;

export const PopMenu = styled.div`
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    max-width: 100%;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 5px 3px;

    max-height: 100px;
    overflow-y: scroll;
    

    &::-webkit-scrollbar { 
        display: none;
    }

    span{
        font-size: 14px;
        color: ${(props) => props.theme.colors.gray.gray_200};
        padding: 5px 10px;
    }
`;

export const ButtonMenu = styled.button`
  width: 100%;
  padding: 5px 10px;
  color: ${(props) => props.theme.colors.gray.gray_800};
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 4px;
  font-size: 16px;
  text-align: start;

  &:hover {
    background-color: ${(props) => props.theme.colors.gray.gray_50};
    border-left: 2px solid ${(props) => props.theme.colors.primary};
    padding-left: 8px;
  }
`;
//Fim PopMenu

export const FormInput = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    .inputText{
        &::placeholder{
            color: ${(props) => props.theme.colors.gray.gray_200};
        }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
        padding: 10px;
        width: 100%;
    }
`;

export const FormInputSmall = styled.div`
    display: flex;
    flex-direction: column;
    width: 40%;

    @media (max-width: 900px) {
        width: 100%;
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;

export const InputNoStyle = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    width: 100%;
    padding: 10px;
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

//Table
export const ContainerTable = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.white};
    box-shadow: 2px 2px 8px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 8px;
    padding: 3px 5px;
    max-height: 350px;
    height: 350px;
`;

export const TotalValue = styled.div`
    display: flex;
    justify-content: flex-end;

    color: ${(props) => props.theme.colors.gray.gray_800};
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th:last-child,
    td:last-child {
        width: 85px;
    }
    
    th:nth-child(1),
    td:nth-child(1){
        width: 40px;

    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    }

    td,
    th {
        text-align: center;
        padding: 10px 0;
    }

    td > div {
        display: flex;
        justify-content: space-around;
    }
    
    & svg {
        font-size: 18px;
        color: ${(props) => props.theme.colors.primary};
    }

    .InputDiscout{
        &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
        border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_50};
        text-align: center;
        padding: 10px;
        width: 100%;
    }

    @media (max-width: 900px) {
        th, td {
            display: none;
        }

        th:nth-child(1),
        td:nth-child(1), /* Primeira coluna */
        th:nth-child(2),
        td:nth-child(2), /* Segunda coluna */
        th:last-child,
        td:last-child { /* Ultima coluna */
            display: table-cell;
        }
    }
`;

export const Thead = styled.thead`
    background-color: ${(props) => props.theme.colors.gray.gray_50};
`;

export const Tbody = styled.tbody`
    display: block;
    max-height: 220px;
    overflow-y: auto;
    width: 100%;

    &::-webkit-scrollbar { 
        display: none;
    }

    /* background-color: aqua; */
`;

export const ButtonIconTable = styled.button`
    text-align: center;
    display: flex;
    background-color: ${(props) => props.theme.colors.white};
    border-radius: 30px;
    padding: 8px;
    box-shadow: 0px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const Button = styled.button`
    background-color: transparent;
`;

// PopMenu dos detalhes do produto na tabela
export const ModalOverlayDesc = styled.div`
  position: relative;
  z-index: 1000;
`;

export const DetalhesProduct = styled.div`
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    background-color: ${(props) => props.theme.colors.red.red_50};
    box-shadow: 0px 2px 2px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 4px;
    padding: 10px;

    width: 300px;
    max-height: 150px;

    border-radius: 16px;
    border-top-left-radius: 4px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    overflow-y: scroll;

    &::-webkit-scrollbar{
        display: none;
    }

    p {
        text-align: justify;
    }
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
`;
// fim forms

export const ContentButton = styled.div`
    display: flex;
    gap: 8px;
`;